export { default as CookiePolicy } from './CookiePolicy';
export { default as PrivacyPolicy } from './PrivacyPolicy';
export { default as TermsOfUse } from './TermsOfUse';
